<template>
  <vs-popup
    fullscreen
    :active.sync="isSidebarActiveLocal"
    :title="this.data.integrationProductName + ' / ' + this.data.productName"
    v-esc="escape"
  >
    <vs-table ref="table" :data="options" class="py-5">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        </div>
    <template slot="thead">
        <vs-th class="w-4/12">
        <vs-button icon-pack="feather" type="flat"
            >{{ integrationSettings.integration.name }}
        </vs-button>
        </vs-th>
        <vs-th class="w-5/12">
        <vs-button color="primary" type="flat"> PickPos Reçete </vs-button>
        </vs-th>
        <vs-th class="w-5/12">
        <vs-button color="primary" type="flat"> PickPos Ekstra </vs-button>
        </vs-th>
        <vs-th>
        <vs-button icon-pack="feather" type="flat">İşlem </vs-button>
        </vs-th>
    </template>

    <template slot-scope="{ data }">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
            <p class="font-medium truncate">
                {{ ((tr.integrationOptionGroupName == null || tr.integrationOptionGroupName == "") ? "" : (tr.integrationOptionGroupName  + "/")) + tr.integrationOptionName }}
            </p>
            </vs-td>
            <vs-td>
              <div class="font-medium truncate mt-2" @click.stop>
                <v-select
                  :disabled="recipes.length == 0"
                  id="recipe"
                  class="w-full"
                  name="Reçete"
                  v-model="tr.recipeStepId"
                  placeholder="Reçete Seçimi"
                  :reduce="(product) => product.id"
                  :options="recipes"
                  :append-to-body="true"
                  :ref="'select_recipe_' + tr.integrationOptionId"
                />
              </div>
                <!-- <v-select
                    class="w-full"
                    placeholder="Reçete Seçimi"
                    :options="recipes"
                    :reduce="(product) => product.id"
                    v-model="tr.recipeStepId"
                    :searchable="true"
                    :append-to-body="false"
                    :ref="'select_recipe_' + tr.integrationOptionId"
                /> -->
            </vs-td>
            <vs-td class="w-5/12">
              <div class="font-medium truncate mt-2" @click.stop>
                <v-select
                  class="w-full"
                  :disabled="extras.length == 0"
                  placeholder="Ekstra Seçimi"
                  :options="extras"
                  :reduce="(product) => product.id"
                  v-model="tr.productExtraId"
                  :searchable="true"
                  :append-to-body="true"
                  :ref="'select_extra_' + tr.integrationOptionId"
                />
              </div>
            </vs-td>
            <vs-td class="whitespace-no-wrap w-1/12">
            <div style="display: flex; gap: 8px; align-items: center;">
                <vs-button
                type="gradient"
                color="success"
                icon-pack="feather"
                icon="icon-check"
                @click="saveProductOption(tr.integrationOptionId)"
                >
                </vs-button>
            </div>
            </vs-td>
        </vs-tr>
        </tbody>
    </template>
    </vs-table>
  </vs-popup>
</template>

<script>
import { getProductOptions, saveProductOption } from "@/api/Integration";
import { getProductByIdForIntegration } from "@/api/Product";

export default {
  data() {
    return {
        recipes: [],
        productRaw: {},
        extras: [],
        options: [],
    };
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    integrationSettings: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar", false);
          this.$validator.reset();
        }
      },
    },
  },
  async mounted() {
    if (this.isSidebarActive) {
      var response = await getProductOptions(
        this.$route.params.slug,
        this.data.integrationProductId
      );
      this.options = response.data.map((option) => ({
        integrationOptionGroupName: option.integrationOptionGroupName,
        integrationOptionName: option.integrationOptionName,
        integrationOptionId: option.integrationOptionId,
        recipeStepId:
        option.recipeStepId == null || option.recipeStepId == "0"
            ? null
            : option.recipeStepId + "-" + (option.rawMaterialId || null),
        productExtraId:
          option.productExtraId == null || option.productExtraId == "0"
            ? null
            : option.productExtraId + "-" + (option.rawMaterialId || null),
      }));

        var productResponse = await getProductByIdForIntegration(this.data.productId);

        this.productRaw = productResponse.data;

        this.recipes = productResponse.data.recipe.recipeSteps
        .filter(
          (f) =>
            f.rawMaterial != null && f.rawMaterial.originRawMaterial != null
        )
        .map((recipe) => ({
          id: recipe.id + "-" + recipe.rawMaterial.id,
          label:
            recipe.rawMaterial.originRawMaterial.name +
            " / " +
            recipe.rawMaterial.name,
        }));

        this.extras = productResponse.data.recipe.productExtras
        .filter(
          (f) =>
            f.rawMaterial != null && f.rawMaterial.originRawMaterial != null
        )
        .map((recipe) => ({
          id: recipe.id + "-" + recipe.rawMaterial.id,
          label:
            recipe.rawMaterial.originRawMaterial.name + " / " + recipe.name,
        }));
    }
  },
  methods: {
    escape() {
      if (this.isSidebarActiveLocal == true) this.isSidebarActiveLocal = false;
    },
    async saveProductOption(id) {
      try {
        const selectRecipeComponent = this.$refs["select_recipe_" + id][0];
        const selectExtraComponent = this.$refs["select_extra_" + id][0];

        if( !selectRecipeComponent || !selectExtraComponent) {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Reçete veya ekstra seçimi yapılmamış.",
          });
          return;
        }

        if(selectRecipeComponent.value != null && selectExtraComponent.value != null) {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Reçete ve ekstra seçimi yapamazsınız.",
          });
          return;
        }

        var recipeStepId = null;
        var extraId = null;
        var rawMaterialId = null;
        if (selectRecipeComponent.value) {
          recipeStepId = selectRecipeComponent.value.split("-")[0] || null;
          rawMaterialId = selectRecipeComponent.value.split("-")[1] || null;
        } else if (selectExtraComponent.value) {
          extraId = selectExtraComponent.value.split("-")[0] || null;
          rawMaterialId = selectExtraComponent.value.split("-")[1] || null;
        }

        var response = await saveProductOption(
          this.$route.params.slug,
          this.data.integrationProductId,
          id,
          extraId,
          recipeStepId,
          rawMaterialId
        );
        if (response && response.status === 200) {
          this.$vs.notify({
            color: "success",
            title: "Başarılı !",
            text: "Ürün başarıyla kaydedildi.",
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + response.status,
            text: "Ürün kaydı başarısız !",
          });
        }
      } catch (e) {
        this.integrationProductList = null;
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
  },
};
</script>

<style>
  .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: static !important;
  }

</style>
